import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 0;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	width: 100%;
	padding: 60px;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export { StyledContainer, StyledLeftContainer };
